'use client';

import { useImport } from '../contexts/ImportContext';

export default function MinimizedImportWidget() {
  const { importProgress, expandImport } = useImport();

  if (!importProgress.isOpen || !importProgress.isMinimized) {
    return null;
  }

  const progress =
    importProgress.totalFiles > 0
      ? Math.round((importProgress.importedCount / importProgress.totalFiles) * 100)
      : 0;

  return (
    <div
      onClick={expandImport}
      className="fixed bottom-4 right-4 bg-white rounded-lg shadow-2xl p-4 cursor-pointer hover:shadow-3xl transition-all duration-200 z-50 border-2"
      style={{
        width: '280px',
        borderColor: importProgress.isCancelling ? '#f97316' : '#3b82f6'
      }}
    >
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center space-x-2">
          <div className="text-xl">
            {importProgress.isComplete
              ? '✅'
              : importProgress.error
                ? '❌'
                : importProgress.isCancelling
                  ? '⏸️'
                  : '📥'}
          </div>
          <span className="font-semibold text-gray-900 text-sm">
            {importProgress.isComplete
              ? 'Complete'
              : importProgress.error
                ? 'Failed'
                : importProgress.isCancelling
                  ? 'Cancelling'
                  : 'Importing'}
          </span>
        </div>
        <span
          className="text-xl font-bold"
          style={{
            color: importProgress.isCancelling ? '#f97316' : '#3b82f6'
          }}
        >
          {progress}%
        </span>
      </div>

      {/* Progress Bar */}
      <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
        <div
          className="h-2 rounded-full transition-all duration-300"
          style={{
            width: `${progress}%`,
            backgroundColor: importProgress.isCancelling ? '#f97316' : '#3b82f6'
          }}
        />
      </div>

      {/* File Count */}
      <div className="text-xs text-gray-600">
        {importProgress.error ? (
          <span className="text-red-600">{importProgress.error}</span>
        ) : importProgress.isComplete ? (
          <span className="text-green-600">
            {importProgress.importedCount} file{importProgress.importedCount !== 1 ? 's' : ''}{' '}
            imported
          </span>
        ) : (
          <span>
            {importProgress.importedCount} / {importProgress.totalFiles} files
          </span>
        )}
      </div>

      {/* Click to expand hint */}
      <div className="text-xs text-gray-400 mt-1 text-center">Click to expand</div>
    </div>
  );
}
